//  import AuthWrapper from "../../layout/wrapper/AuthWrapper";
import React, { useEffect, useState } from "react";
import styles from "../../styles/pages/login.module.scss";
import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  Grid,
  Input,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Stack,
  Typography,
  Zoom,
} from "@mui/material";

import assest from "../../json/assest/index";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import IconButton from "@mui/material/IconButton";
import VisibilityOff from "../../ui/Icons/VisibilityOff";
import Visibility from "../../ui/Icons/Visibility";
import Alert from "@mui/material/Alert";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { SubmitHandler, useForm } from "react-hook-form";
import logo from "../../public/assets/images/logo.svg";

import { parseCookies, setCookie } from "nookies";

import { setLoginData } from "../../redux-toolkit/slices/userSlice";
import useNotiStack from "../../hooks/useNotistack";
import { useAppDispatch } from "../../hooks/useAppDispatch";
import { useLogin } from "../../hooks/useUser";
import { Link, useNavigate } from "react-router-dom";
import { setCookieClient } from "../../lib/functions/storage.lib";
import ApiLoader from "../../components/Loaders/ApiLoader";
// import AuthWrapper from "../../layout/wrapper/AuthWrapper";
const schema = yup.object().shape({
  email: yup
    .string()
    .required("This field is required ")
    .email("Please insert valid Email"),
  password: yup.string().required("Incorrect password. Please try again."),
  // .min(8, "Password length should be at least 8 characters")
  // .max(17, "Password cannot exceed more than 16 characters"),
  role_id: yup.number(),
});
const Index = () => {
  const {
    handleSubmit,
    control,
    register,
    setValue,
    reset,
    setError,
    formState: { errors },
    formState,
    watch,
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      // role_id: 7,
      email: "",
      password: "",
    },
  });

  const [showPassword, setShowPassword] = React.useState(false);
  const [showPasswordToggle, setShowPasswordToggle] = useState(false);
  const [check, setCheck] = useState(false);
  const { toastSuccess, toastError } = useNotiStack();
  const dispatch = useAppDispatch();
  const [loaderState, setLoaderState] = useState(false);
  const { isSubmitting } = formState;
  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const cookieOptions = {
    maxAge: 30 * 24 * 60 * 60, // 30 days in seconds
    path: ("/copywriters", "/"),
    domain: ("https://vrlsnrtst.com", ".example.com", ".example.com"), // Set the domain to your desired domain (e.g., '.example.com' for all subdomains)
  };

  useEffect(() => {
    const cookies = parseCookies();
    const _value = cookies?.cred ? JSON.parse(cookies.cred) : null;
    const _value1 = cookies?.userDetails123
      ? JSON.parse(cookies.userDetails123)
      : null;

    if (_value) {
      setCheck(true);
      reset(_value1);
    } else {
      setCheck(false);
    }
  }, []);

  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    autoplaySpeed: 5000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    arrows: false,
  };

  const { mutate, isSuccess, isLoading } = useLogin();
  const navigate = useNavigate();

  const onSubmit = (data) => {
    mutate(data, {
      onSuccess: (data) => {
        if (data?.token) {
          dispatch(setLoginData(data?.user));
          setCookieClient("token", data.token);
          setCookieClient("role_id", data?.user?.role_id);
          setCookieClient("cred", check ? JSON.stringify(data?.user) : "");

          // setCookieClient( 'yourCookieName',   check ? JSON.stringify(data?.user) : cookieOptions, );

          setCookieClient("userdetails", JSON.stringify(data.user));
          console.warn("role_id1", data?.user?.role_id);
          // router.replace("/");
          {
            data?.user?.role_id === 9
              ? navigate("/content-buyer-dashboard")
              : data?.user?.role_id === 1
              ? navigate("/")
              : data?.user?.role_id === 7
              ? navigate("/manager-dashboard")
              : data?.user?.role_id === 6
              ? navigate("/qcagent-dashboard")
              : data?.user?.role_id === 5
              ? navigate("/user/copywriter")
              : data?.user?.role_id === 4
              ? navigate("/editor-dashboard")
              : data?.user?.role_id === 3
              ? navigate("/memberpartner-dashboard")
              : data?.user?.role_id === 2
              ? navigate("/memberpartner-dashboard")
              : navigate("/");
          }

          // window.location.href = "/";
          reset();
        } else {
          setError("email", {
            message:
              "Email or Password is incorrect. Please double-check and try again.",
          });
        }
      },
    });
  };

  const passwordWatch = watch("password");
  useEffect(() => {
    if (!showPasswordToggle && !passwordWatch) {
      setShowPassword(false);
    }
  }, [passwordWatch, showPasswordToggle]);

  return (
    // <AuthWrapper>
    <Box className={styles.pageLogin}>
      <ApiLoader loading={isLoading} />
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={0}>
          <Grid item xs={12} md={6}>
            <Box className={styles.panelLeft}>
              <Link href="/">
                <img src={logo} alt="img" />
              </Link>
              <Box className={styles.authContent}>
                <Typography variant="h1">ViralSnare HUB</Typography>

                <Slider {...settings}>
                  <div>
                    <Typography variant="body1">
                      Evaluate your video submissions effortlessly with your
                      ViralSnare account!
                    </Typography>
                  </div>
                  <div>
                    <Typography variant="body1">
                      Stay connected and on the top of your submissions through
                      our ONE-STOP shop!
                    </Typography>
                  </div>
                  <div>
                    <Typography variant="body1">
                      Enhance communication and collaboration thanks to your
                      HUB.
                    </Typography>
                  </div>
                  <div>
                    <Typography variant="body1">
                      Collaborate seamlessly with team members across all stages
                      of the content lifecycle.
                    </Typography>
                  </div>
                </Slider>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box className={styles.panelRight}>
              <Typography variant="h2">Log In</Typography>
              <Box className={styles.formSec}>
                <Box className={styles.formGroup}>
                  <label>Email address</label>
                  <OutlinedInput
                    error={errors?.email?.message ? true : false}
                    type="email"
                    placeholder={""}
                    {...register("email")}
                  />
                </Box>

                <Box className={`${styles.formGroup} ${styles.formPassword}`}>
                  <label>Password</label>
                  <OutlinedInput
                    {...register("password")}
                    error={errors?.email?.message ? true : false}
                    type={showPassword ? "text" : "password"}
                    onFocus={() => {
                      setShowPasswordToggle(true);
                    }}
                    onBlur={() => {
                      setShowPasswordToggle(false);
                    }}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          // onMouseDown={handleMouseDownPassword}
                          edge="end"
                        >
                          {/* {showPassword ? <VisibilityOff /> : <Visibility />} */}

                          {watch("password").length === 0 ? (
                            ""
                          ) : showPassword ? (
                            <VisibilityOff />
                          ) : (
                            <Visibility />
                          )}
                        </IconButton>
                      </InputAdornment>
                    }
                  />

                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    flexWrap="wrap"
                    alignItems="center"
                    className={styles.rememberGroup}
                  >
                    <label className={styles.customCheckBox}>
                      <input
                        type="checkbox"
                        checked={check}
                        onChange={() => setCheck(!check)}
                      />
                      <span className={styles.checkmark}></span>
                      <span className={styles.checkLabel}>
                        Remember my session
                      </span>
                    </label>
                    <Link to="/Password-recovery">I forgot my password.</Link>
                  </Stack>
                </Box>

                <Box className={styles.formGroup}>
                  <Button
                    type="submit"
                    className={styles.btnlogin}
                    // disabled={loaderState}
                    disabled={
                      watch("email").length === 0 ||
                      watch("password").length === 0
                    }
                  >
                    {isLoading ? <p>Logging in...</p> : "Log In"}
                  </Button>
                </Box>

                {errors.email && (
                  <Alert severity="error" className={styles.errorAlert}>
                    {errors.email.message}
                  </Alert>
                )}

                {errors.password && (
                  <Alert
                    severity="error"
                    className={styles.errorAlert}
                    sx={{ marginTop: "10px !important" }}
                  >
                    {errors.password.message}
                  </Alert>
                )}
              </Box>
            </Box>
          </Grid>
        </Grid>
      </form>
    </Box>
    //  </AuthWrapper>
  );
};

export default Index;
